import { render, staticRenderFns } from "./page11.vue?vue&type=template&id=220cf67c&scoped=true&"
import script from "./page11.vue?vue&type=script&lang=js&"
export * from "./page11.vue?vue&type=script&lang=js&"
import style0 from "./page11.vue?vue&type=style&index=0&id=220cf67c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220cf67c",
  null
  
)

export default component.exports